import { createStyleContent } from '../themeUtils';
import { ThemeOthers } from '../types';

export const getOtherStyleContent = (
  others: ThemeOthers | undefined,
  othersMapping: Partial<Record<string, string | string[]>>,
) => {
  if (!others || Object.keys(others).length === 0) {
    return '';
  }

  const othersThemeStyles: string[] = [];

  for (const [key, value] of Object.entries(others)) {
    const cssVarNames = othersMapping[key];
    if (cssVarNames) {
      const cssVarNamesArray = Array.isArray(cssVarNames) ? cssVarNames : [cssVarNames];
      cssVarNamesArray.forEach(cssVarName => {
        othersThemeStyles.push(`${cssVarName}: ${value};`);
      });
    }
  }

  return createStyleContent(othersThemeStyles, ':root:root:root');
};
